export default __webpack_public_path__ + "static/media/no-image.92448b83.svg";